import React, { useEffect, useState } from 'react';
import images from '@assets/images-base';

import { CardItem, SpaceBase } from 'styles';
import { EStatusCompany, EStatusFile, MAX_LENGTH } from 'constants/constants';
import { defaultFiles, ICompany, ICompanyInitData, IDirectDebitSubCompany, IFile } from 'constants/operatorSite';
import { ErrorOperator, WrapperInput } from '@pages/OperatorSite/Operators/CreateOperator/createOperatorStyle';
import DatePickerCustom from '@components/CompanySite/AttendanceRecord/DatePickerCustom/DatePickerCustom';
import {
  DebitCardItem, BtnAddFile, ItemWrapper, TickedIcon, TitleWrapper, WrapperDebitSubCompany,
  BasicFormItem,
  CheckboxRadio,
  RadioGroupRow,
  RadioStyled,
  CompanyDirectItemWrapper,
  AddTickedIcon,
  WrapperInputDate,
} from './CompanyStyle';
import { Radio } from 'antd';
import InputCard from '@components/Input/InputCard';
import { colors } from 'constants/colorsBase';
import {
  ElementCard,
  FirstItem,
  TitleItem,
} from '@containers/OperatorSite/Operator/DetailOperator/detailOperatorStyle';
import { CONST_COMPANY_DEBIT, CONST_SETTING_SALARY } from 'constants/language';
import { on } from 'events';
import SelectCompanyPairedWithDirectDebit from '@components/common/SelectCompanyPairedWithDirectDebit/SelectCompanyPairedWithDirectDebit';
import useSelectCompanyPairedWithDirectDebit, { ICompanyPairedResponse } from '@components/common/SelectCompanyPairedWithDirectDebit/useSelectCompanyPairedWithDirectDebit';
import { Dayjs } from 'dayjs';


const CompanyDirectItem = ({
  item,
  disabled,
  onRemove,
  onChangeCompanyDirectDebit,
  companyId,
  listCompanyPairedInit,
}: {
  item: IDirectDebitSubCompany;
  disabled?: boolean;
  onRemove: () => void;
  onChangeCompanyDirectDebit: (code: string, company_name: string) => void;
  companyId?: number | undefined;
  listCompanyPairedInit?: ICompanyPairedResponse[] | any;
}) => {
  const [value, setValue] = useState('');
  useEffect(() => {
    if (!value) {
      setValue(item.code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);
  return (
    <WrapperInput width="20rem" >
      <CompanyDirectItemWrapper>
        <SelectCompanyPairedWithDirectDebit
          value={item?.code || undefined}
          margin={[0, 0.313, 0, 0.626]}
          onChangeCompanyPairedWithDirectDebit={onChangeCompanyDirectDebit}
          company={item}
        // listCompanyPairedInit={listCompanyPairedInit}
        />
        <SpaceBase width={0.313} />
        <TickedIcon
          src={images.company.deleteCompany}
          alt=""
          onClick={() => {
            onRemove();
          }}
        />
      </CompanyDirectItemWrapper>
      <ErrorOperator>
        {item.isError && <SpaceBase width={1} />} {item.isError}
      </ErrorOperator>
    </WrapperInput>
  );
};

interface ICompanyDirectDebit {
  error: ICompany;
  companyData: ICompany;
  constData?: ICompanyInitData;
  directDebitSubCompanies: IDirectDebitSubCompany[];
  setDirectDebitSubCompanies: (subCompanies: IDirectDebitSubCompany[]) => void;
  onChangeDirectDebitEnabled: (e: any) => void;
  onChangeDirectDebitAccountNumber: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDirectDebitInvoiceNumber: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDirectDebitStartMonth: (e: Dayjs) => void;
  isCreate?: boolean;
  companyId?: number | undefined;
  canSettingDirectDebit?: boolean;
}

const CompanyDirectDebit = ({
  error,
  companyData,
  constData,
  onChangeDirectDebitEnabled,
  onChangeDirectDebitAccountNumber,
  onChangeDirectDebitInvoiceNumber,
  onChangeDirectDebitStartMonth,
  directDebitSubCompanies,
  setDirectDebitSubCompanies,
  isCreate,
  companyId,
  canSettingDirectDebit,
}: ICompanyDirectDebit) => {
  // const listCompanyPairedInit = useSelectCompanyPairedWithDirectDebit(companyId).listCompanyPaired;
  const addCompany = () => {
    const newCompany = [...directDebitSubCompanies];
    newCompany.push({
      name: '',
      code: '',
      id: 0,
      isError: false,
    });
    setDirectDebitSubCompanies(newCompany);
    error.directDebitSubCompanies = undefined;
  };

  const onRemove = (idxRemove: number) => {
    const newSubCCompany: IDirectDebitSubCompany[] = [...directDebitSubCompanies].filter((_, index) => index !== idxRemove);
    setDirectDebitSubCompanies(newSubCCompany);
  };

  const onChangeCompanyDirectDebit = (idxChange: number, code: string, name: string) => {
    setDirectDebitSubCompanies(
      directDebitSubCompanies.map((element: IDirectDebitSubCompany, index: number) => {
        return index === idxChange
          ? { ...element, code: code, name, isError: false }
          : element
      })
    );
  };

  return (
    <>
      {!canSettingDirectDebit ? (
        <>
          <DebitCardItem>
            <FirstItem>{CONST_COMPANY_DEBIT.SETTING_GROUP}</FirstItem >
            <div style={{
              color: '#ff4d4f',
              padding: '0.5rem',
            }}>
              {CONST_COMPANY_DEBIT.CANNOT_SETTING_DIRECT_DEBIT}
            </div>
          </DebitCardItem >
        </>
      ) : (
        <>
          <DebitCardItem>
            <FirstItem>{CONST_COMPANY_DEBIT.SETTING_GROUP}</FirstItem >
          </DebitCardItem >
          <DebitCardItem>
            <FirstItem>{CONST_COMPANY_DEBIT.DIRECT_DEBIT_ENABLE}</FirstItem>
            <BasicFormItem
              labelCol={{ span: 24 }}
              colon={false}
              className="not-required"
              label={
                <RadioGroupRow
                  value={companyData.directDebitEnabled}
                  onChange={onChangeDirectDebitEnabled}
                >
                  <RadioStyled value={false}>{CONST_COMPANY_DEBIT.DISABLE}</RadioStyled>
                  <RadioStyled value={1}>{CONST_COMPANY_DEBIT.ENABLE}</RadioStyled>
                </RadioGroupRow>
              }
              name="enableDirectDebit"
              rules={[{ required: false, message: '' }]}
            >
            </BasicFormItem>
          </DebitCardItem>
          <DebitCardItem>
            <FirstItem>{CONST_COMPANY_DEBIT.DIRECT_DEBIT_START_MONTH}</FirstItem>
            <WrapperInputDate>
              <DatePickerCustom
                onChangeMonth={onChangeDirectDebitStartMonth}
                month={companyData.directDebitStartMonth}
                normalPicker={false}
                isHasBtnChange={false}
                allowClear={true}
                placeholder=""
              />
            </WrapperInputDate>
          </DebitCardItem>
          <DebitCardItem>
            <FirstItem>{CONST_COMPANY_DEBIT.CUSTOMER_ID}</FirstItem>
            <WrapperInput>
              <InputCard
                width={18.75}
                height={2.5}
                onChange={onChangeDirectDebitAccountNumber}
                isShadow={true}
                value={companyData.directDebitAccountNumber || ''}
                placeholder={CONST_COMPANY_DEBIT.CUSTOMER_ID}
                maxLength={MAX_LENGTH.DEFAULT}
                margin={[0, 4]}
                backGroundColor={colors.white}
              />
              <ErrorOperator>{error.directDebitAccountNumber}</ErrorOperator>
            </WrapperInput>
          </DebitCardItem>
          <DebitCardItem>
            <FirstItem>{CONST_COMPANY_DEBIT.INVOICE_NUMBER}</FirstItem>
            <WrapperInput>
              <InputCard
                width={18.75}
                height={2.5}
                onChange={onChangeDirectDebitInvoiceNumber}
                isShadow={true}
                value={companyData.directDebitInvoiceNumber || ''}
                placeholder={CONST_COMPANY_DEBIT.INVOICE_NUMBER}
                maxLength={MAX_LENGTH.DEFAULT}
                margin={[0, 4]}
                backGroundColor={colors.white}
              />
              <ErrorOperator>{error.directDebitInvoiceNumber}</ErrorOperator>
            </WrapperInput>
          </DebitCardItem>
          <DebitCardItem>
            <FirstItem width='12rem'>{CONST_COMPANY_DEBIT.SUB_COMPANY}</FirstItem>
            <div>
              <WrapperDebitSubCompany>
                {error.directDebitSubCompanies && typeof error.directDebitSubCompanies === 'string' && (
                  <ErrorOperator>
                    <>
                      <SpaceBase width={1} />
                      {error.directDebitSubCompanies}
                    </>
                  </ErrorOperator>
                )}
                {directDebitSubCompanies?.map((element: IDirectDebitSubCompany, index: number) => (
                  <React.Fragment key={index}>
                    <CompanyDirectItem
                      item={element}
                      onRemove={() => onRemove(index)}
                      onChangeCompanyDirectDebit={(code, name) => onChangeCompanyDirectDebit(index, code, name)}
                    // companyId={companyId}
                    // listCompanyPairedInit={listCompanyPairedInit}
                    />
                  </React.Fragment>
                ))}
                <AddTickedIcon
                  src={images.company.addCompany}
                  alt=""
                  onClick={addCompany}
                />
              </WrapperDebitSubCompany>
            </div>
          </DebitCardItem>
        </>
      )}
    </>
  );
};

export default CompanyDirectDebit;
